import { c as createIconsConfig } from "../create-icons-config.js";
const getIconDefaultConfig = () => createIconsConfig({});
export { getIconDefaultConfig as g };
//# sourceMappingURL=default.js.map
